export class DataProvider {
    initForm: any;
    form: any;
    setForm: any;

    constructor(form: any, setForm: any) {
        this.initForm = this.clone(form);
        this.form = form;
        this.setForm = setForm;
    }

    clone = (data: any) => {
        return JSON.parse(JSON.stringify(data));
    }

    setData = (e: any) => {
        let f = { ...this.form }

        if (e.detail !== undefined && e.detail.checked !== undefined) {
            f[e.target.name].value = e.detail.checked
        } else if (e.target.value !== undefined) {
            f[e.target.name].value = e.target.value
        } else {
            f[e.target.name].value = ''
        }

        this.setForm(f);
    }

    setValue = (e: any) => {
        let f = { ...this.form }

        if (e.detail !== undefined && e.detail.checked !== undefined) {
            f[e.target.name].value = e.detail.checked
        } else if (e.target.value !== undefined) {
            f[e.target.name].value = e.target.value
        } else {
            f[e.target.name].value = ''
        }

        this.setForm(f);
    }

    setValueWithData = (e: any, val: any) => {
        let f = { ...this.form }

        if (e.detail !== undefined && e.detail.checked !== undefined) {
            f[e.target.name].value = val
        } else if (e.target.value !== undefined) {
            f[e.target.name].value = val
        } else {
            f[e.target.name].value = ''
        }

        this.setForm(f);
    }

    setLabelWithData = (e: any, val: any) => {
        let f = { ...this.form }

        if (e.detail !== undefined && e.detail.checked !== undefined) {
            f[e.target.name].label = val
        } else if (e.target.value !== undefined) {
            f[e.target.name].label = val
        } else {
            f[e.target.name].label = ''
        }

        this.setForm(f);
    }

    validation = (form: any) => {
        let hasError = false;
        const formData = { ...this.form }

        for (const [field, data] of Object.entries(formData)) {
            let alreadyError = false;

            for (const [item, condition] of Object.entries(formData[field].validation)) {
                if (item == 'required' && condition == true) {
                    console.log(field);
                    
                    if (formData[field].value.length == 0) {
                        formData[field].error = "این فیلد را تکمیل کنید.";
                        hasError = true;
                        alreadyError = true;
                    } else {
                        if (!alreadyError) formData[field].error = "";
                    }
                } else if (item == 'checkbox_required') {
                    if (formData[field].value == false) {
                        formData[field].error = "این گزینه را تیک بزنید.";
                        hasError = true;
                        alreadyError = true;
                    } else {
                        if (!alreadyError) formData[field].error = "";
                    }
                } else if (item == 'min') {
                    if (formData[field].value.length > 0 && formData[field].value.length < Number(condition)) {
                        formData[field].error = "حداقل " + condition + " کاراکتر وارد کنید.";
                        hasError = true;
                        alreadyError = true;
                    } else {
                        if (!alreadyError) formData[field].error = "";
                    }
                } else if (item == 'max') {
                    if (formData[field].value.length > 0 && formData[field].value.length > Number(condition)) {
                        formData[field].error = "حداکثر " + condition + " کاراکتر وارد کنید.";
                        hasError = true;
                        alreadyError = true;
                    } else {
                        if (!alreadyError) formData[field].error = "";
                    }
                } else if (item == 'min_amount') {
                    if (formData[field].value.length > 0 && Number(formData[field].value.replace(/\D+/, '')) < Number(condition)) {
                        formData[field].error = "حداقل مبلغ " + Number(condition).toPrice() + " می باشد.";
                        hasError = true;
                        alreadyError = true;
                    } else {
                        if (!alreadyError) formData[field].error = "";
                    }
                }
            }
        }

        this.setForm(formData)

        return !hasError;
    }
    
    reset = () => {
        this.form = this.clone(this.initForm)
        this.setForm(this.form)
    }
}